import isMobile from './helpers/mobile';

const build = () => {

    if (isMobile()) {
        $('.emerging-conflicts .section-content .col-md-5').addClass('col-md-12');
        $('.emerging-conflicts .section-content .col-md-5').removeClass('col-md-5');
        $('.emerging-conflicts .section-footer .col-md-4').addClass('col-md-12');
        $('.emerging-conflicts .section-footer .col-md-4').removeClass('col-md-4');
        $('.emerging-conflicts .section-footer .col-md-7').addClass('col-md-10');
        $('.emerging-conflicts .section-footer .col-md-7').removeClass('col-md-7');

        $('.covid .col-md-4').addClass('col-md-12');
        $('.covid .col-md-4').removeClass('col-md-4');
        $('.covid .col-md-7').addClass('col-md-12');
        $('.covid .col-md-7').removeClass('offset-md-1');
        $('.covid .col-md-7').removeClass('col-md-7');

    }
    new Accordion('.accordion-container', {
        duration: 400,
        showMultiple: false,
        openOnInit: '{ 0 }',
        onOpen: function(currentElement) {

            $('#header').addClass('auto-scrolling');



            var scrollPosition = $('#' + currentElement.id).offset().top;
            $('html,body').animate({
                scrollTop: scrollPosition
            }, 200);

            setTimeout(function() { $('#header').removeClass('auto-scrolling') }, 1010)
        }
    });
}


export default () => {
    build()
}
